import type { InventoryResource } from '@repo/api-gw-sdk';

import { SidePanelPropsTable } from '../../../sidePanelPropsTable';

export const RedshiftSection = ({
  resource,
}: {
  resource: InventoryResource;
}) => {
  const redshiftProps = resource.resourceProperties?.awsRedshift;

  if (!redshiftProps) {
    return null;
  }

  return (
    <SidePanelPropsTable withDividers columnSpace='medium'>
      <tbody>
        <tr>
          <td className='props-col'>Cluster Identifier</td>
          <td className='break-all'>{redshiftProps.clusterIdentifier}</td>
        </tr>
        {redshiftProps.clusterType && (
          <tr>
            <td className='props-col'>Cluster Type</td>
            <td>{redshiftProps.clusterType}</td>
          </tr>
        )}
        {redshiftProps.nodeType && (
          <tr>
            <td className='props-col'>Node Type</td>
            <td>{redshiftProps.nodeType}</td>
          </tr>
        )}
        {redshiftProps.numberOfNodes !== undefined &&
          redshiftProps.numberOfNodes > 0 && (
            <tr>
              <td className='props-col'>Number of Nodes</td>
              <td>{redshiftProps.numberOfNodes}</td>
            </tr>
          )}
        {redshiftProps.status && (
          <tr>
            <td className='props-col'>Status</td>
            <td>{redshiftProps.status}</td>
          </tr>
        )}
        {redshiftProps.endpoint && (
          <tr>
            <td className='props-col'>Endpoint</td>
            <td className='break-all'>{redshiftProps.endpoint}</td>
          </tr>
        )}
        {redshiftProps.endpointPort !== undefined &&
          redshiftProps.endpointPort > 0 && (
            <tr>
              <td className='props-col'>Port</td>
              <td>{redshiftProps.endpointPort}</td>
            </tr>
          )}
        {redshiftProps.dbName && (
          <tr>
            <td className='props-col'>Database</td>
            <td>{redshiftProps.dbName}</td>
          </tr>
        )}
        {redshiftProps.vpcId && (
          <tr>
            <td className='props-col'>VPC ID</td>
            <td>{redshiftProps.vpcId}</td>
          </tr>
        )}
        {redshiftProps.encrypted !== undefined && (
          <tr>
            <td className='props-col'>Encrypted</td>
            <td>{redshiftProps.encrypted ? 'Yes' : 'No'}</td>
          </tr>
        )}
        {redshiftProps.kmsKeyId && (
          <tr>
            <td className='props-col'>KMS Key ID</td>
            <td className='break-all'>{redshiftProps.kmsKeyId}</td>
          </tr>
        )}
      </tbody>
    </SidePanelPropsTable>
  );
};
